<template>
  <div class="editor">
    <textarea ref="texteditor" :value="value" @input="update"></textarea>
    <div
      class="preview reading-context"
      v-dompurify-html="compiledMarkdown"
    ></div>
  </div>
</template>

<script>
import marked from 'marked';
import _debounce from 'lodash/debounce';

export default {
  name: 'markdown-editor',
  props: ['value'],
  data: function() {
    return {
      input: '',
    };
  },
  mounted() {
    this.input = this.value;
  },
  computed: {
    compiledMarkdown: function() {
      return marked(this.input);
    },
  },
  methods: {
    update: _debounce(function(e) {
      this.input = e.target.value;
      this.$emit('input', this.$refs.texteditor.value);
    }, 300),
  },
};
</script>

<style lang="scss" scoped>
.editor {
  margin: 0;
  border: 1px solid color('grey');
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  height: 720px;

  textarea,
  div {
    display: inline-block;
    vertical-align: top;
    padding: 0 20px;
  }

  textarea {
    flex: 1;
    border: none;
    border-right: 1px solid color('grey');
    resize: none;
    outline: none;
    background-color: #f6f6f6;
    font-size: 14px;
    padding: 20px;
  }

  code {
    color: #f66;
  }
}

.preview {
  width: 800px;
  overflow-y: auto;
}
</style>
